
function checkUserAndRedirect(user, deferred, $location) {
    console.log('checkUserAndRedirect ' + user.UserID + ' Contato: ' + user.ContactID);
    //console.log(user);
    if (user.UserType != 'AGENT') {
        if (!user.Contacts || user.Contacts.length <= 0) {
            deferred.reject();
            $location.path("/QuoteError/" + user.UserID);
            return;
        }
    }

    var numContacts = user.Contacts.length;
    if (numContacts == 1) {
        user.ContactID = user.Contacts[0];    
    }

    if (user.UserType == 'AGENT' || numContacts > 1) {
        deferred.resolve(true);
    } else {
        deferred.reject();
        $location.path("/ContactDashboard/" + user.ContactID);
        //$location.path("/Home/");
    }
}

var checkRouting = function ($q, $rootScope, $location, $http) {
    console.log('checkRouting ');
    //console.log($rootScope.loggedUser);
    //console.log($rootScope.LoggedUser);
    var deferred = $q.defer();
    if ($rootScope.loggedUser) {
        checkUserAndRedirect($rootScope.loggedUser, deferred, $location);
    } else {
        $http.get("../Api/UserSettingApi/GetUser")
            .success(function (response) {
                $rootScope.loggedUser = response;
                checkUserAndRedirect(response, deferred, $location);
            })
            .error(function () {
                deferred.reject();
                $location.path("/");
            });
        return deferred.promise;
    }
};

seedWebApp.config(['$locationProvider', '$routeProvider', '$mdThemingProvider', 'angularAuth0Provider',
function ($locationProvider, $routeProvider, $mdThemingProvider, angularAuth0Provider) {

    //Thema Angular Material
    $mdThemingProvider.theme('default').primaryPalette('blue').accentPalette('orange');

    console.log('routeProvider.shippingDocs ');

    $routeProvider.when('/shippingDocs/', {
        templateUrl: './SPA/pub/shippingdocs.html' + seedWebApp.buildVersion,
        controller: 'ShippingDocsCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Orders',
    });

    $routeProvider.when('/Dashboard/', {
        templateUrl: './SPA/quotes/dashboard.html' + seedWebApp.buildVersion,
        controller: 'DashboardController',
        reloadOnSearch: false,
        moduleName: 'Dashboard',
        resolve: {
            factory: checkRouting
        }
    });

    //$routeProvider.when('/Orders/:id', {
    //    templateUrl: './SPA/orders/indexOrders.html' + seedWebApp.buildVersion,
    //    controller: 'IndexOrdersCtrl',
    //    reloadOnSearch: false,
    //    reloadOnPath: false,
    //    moduleName: 'Orders',
    //});

    $routeProvider.when('/Orders/', {
        templateUrl: './SPA/orders/indexOrders.html' + seedWebApp.buildVersion,
        controller: 'IndexOrdersCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Orders',
    });

    $routeProvider.when('/Home/', {
        templateUrl: './SPA/orders/indexOrders.html' + seedWebApp.buildVersion,
        controller: 'IndexOrdersCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Orders',
    });
        
    $routeProvider.when('/QuoteError/:id', {
        templateUrl: './SPA/quotes/quoteError.html' + seedWebApp.buildVersion,
        controller: 'QuoteErrorController',
        reloadOnSearch: false,
        moduleName: 'Dashboard'
    });

    $routeProvider.when('/ContactDashboard/:id', {
        templateUrl: './SPA/quotes/contactDashboard.html' + seedWebApp.buildVersion,
        controller: 'ContactDashboardCtrl',
        reloadOnSearch: false,
        moduleName: 'Dashboard'
    });    

    //$routeProvider.when('/Materials/', {
    //    templateUrl: './SPA/materials/indexMaterials.html' + seedWebApp.buildVersion,
    //    controller: 'IndexMaterialsCtrl',
    //    reloadOnSearch: false,
    //    reloadOnPath: false,
    //    moduleName: 'Stocks',
    //});

    $routeProvider.when('/Stocks/', {
        templateUrl: './SPA/materials/indexMaterials.html' + seedWebApp.buildVersion,
        controller: 'IndexMaterialsCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Stocks',
    });

    $routeProvider.when('/Dics/', {
        templateUrl: './SPA/dics/indexDics.html' + seedWebApp.buildVersion,
        controller: 'IndexDicsCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Dics',
    });

    $routeProvider.when('/Issues/', {
        templateUrl: './SPA/helpdesk/indexIssues.html' + seedWebApp.buildVersion,
        controller: 'IndexIssuesCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Issues',
    });

    $routeProvider.when('/Logistics/', {
        templateUrl: './SPA/logistics/indexLogistics.html' + seedWebApp.buildVersion,
        controller: 'IndexLogisticsCtrl',
        reloadOnSearch: false,
        reloadOnPath: false,
        moduleName: 'Logistics',
    });

    $routeProvider.when('/Prices/', {
        templateUrl: './SPA/Prices/indexPrices.html',
        controller: 'PricesController',
        reloadOnSearch: false,
        moduleName: 'Prices',
    });

    //$routeProvider.when('/Integrations/', {
    //    templateUrl: './SPA/Integrations/Integrations.html',
    //    controller: 'IntegrationsCtrl',
    //    reloadOnSearch: false,
    //    moduleName: 'Integrations'
    //});

    $routeProvider.when('/Integrations/', {
        templateUrl: './SPA/Integrations/indexIntegrations.html' + seedWebApp.buildVersion,
        controller: 'IndexIntegrationsCtrl',
        reloadOnSearch: false,
        moduleName: 'Integrations'
    });

    $routeProvider.when('/Integrations/IntegrationScopes/:id', {
        templateUrl: './SPA/Integrations/IntegrationScopes.html',
        controller: 'IntegrationScopesController',
        reloadOnSearch: false,
        moduleName: 'Integrations'
    });

    //:id/:scopeID
    $routeProvider.when('/Integrations/IntegrationScope/:id/:scopeID', {
        templateUrl: './SPA/Integrations/IntegrationScope.html',
        controller: 'IntegrationScopeController',
        reloadOnSearch: false,
        moduleName: 'Integrations'
    });

    $routeProvider.when('/Settings/', {
        templateUrl: './SPA/settings/indexSettings.html' + seedWebApp.buildVersion,
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'General',
        tab: 'none',
    });

    $routeProvider.when('/Settings/Users/', {
        templateUrl: './SPA/settings/indexSettings.html' + seedWebApp.buildVersion,
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'Users',
        tab: 'users',
    });

    $routeProvider.when('/Settings/Status/', {
        templateUrl: './SPA/settings/indexSettings.html' + seedWebApp.buildVersion,
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'Status',
        tab: 'status',
    });

    $routeProvider.when('/Settings/Plants/', {
        templateUrl: './SPA/settings/indexSettings.html',
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'Plants',
        tab: 'plants',
    });

    $routeProvider.when('/Settings/Emails/', {
        templateUrl: './SPA/settings/indexSettings.html' + seedWebApp.buildVersion,
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'Emails',
        tab: 'emails',
    });

    $routeProvider.when('/Settings/Docs/', {
        templateUrl: './SPA/settings/indexSettings.html' + seedWebApp.buildVersion,
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'Docs',
        tab: 'docs',
    });

    $routeProvider.when('/Settings/Stages/', {
        templateUrl: './SPA/settings/indexSettings.html' + seedWebApp.buildVersion,
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'Stages',
        tab: 'stages',
    });

    $routeProvider.when('/Contacts/', {
        templateUrl: './SPA/contacts/indexContacts.html' + seedWebApp.buildVersion,
        controller: 'IndexContactsController',
        reloadOnSearch: false,
        moduleName: 'Contacts',
        pageName: 'Clients',
        tab: 'contacts',
    });

    $routeProvider.when('/Settings/DBUpdater/', {
        templateUrl: './SPA/settings/indexSettings.html',
        controller: 'SettingsController',
        reloadOnSearch: false,
        moduleName: 'Settings',
        pageName: 'DBUpdater',
        tab: 'dbUpdater',
    });

    //$routeProvider.otherwise({ redirectTo: '/Home/' });
    $routeProvider.otherwise({ redirectTo: '/Home/' });

    //$routeProvider.otherwise({
    //    templateUrl: './SPA/404page.html',
    //    controller: '404PageController',
    //    reloadOnSearch: false,
    //    reloadOnPath: false,
    //    moduleName: 'Orders',
    //});


    $locationProvider.hashPrefix('');

    // Comment out the line below to run the app
    // without HTML5 mode (will use hashes in routes)
    $locationProvider.html5Mode(true);
}]);

